import React, {useContext} from 'react'

export const UserContext = React.createContext<string | undefined>(undefined)
UserContext.displayName = 'User'

export const useUser = () => useContext(UserContext)
